import React from "react";
import AddContentPage from "../catalogue/AddContentPage";
import { createGeneralContent } from "../../../store/actions/uploadMediaAction";

const AddMovie = () => (
  <AddContentPage
    title="Add Video"
    genreType="movies"
    createAction={createGeneralContent}
    savedKey="savedGeneralContent"
    editPath={(id) => `/dashboard/update-video/${id}`}
    missingKey="Please Fill Video Info!"
    successKey="Video Info Submitted Successfully!"
    cancelPath="/dashboard/video-list"
  />
);

export default React.memo(AddMovie);
